import React from 'react'
import Button from 'material-ui/Button'
import Switch from 'material-ui/Switch'
import { withStyles } from 'material-ui/styles'
import styles from '../styles'

import Table from '../../table'
import ConfirmDialog from '../../common/dialog/confirm'
import withRole from '../../hoc/role'

import {
  dateTimeFormatter,
  getISODateTimeString
} from '../../../common/utils'

import {
  ROLES_IDEAL,
  ROLES_CLIENT,
  ROLES_IDEAL_ADMIN,
  ROLES_CLIENT_ADMIN,
  ROLES_CLIENT_MANAGER
} from '../../../common/constants'

import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'
import TimePicker from 'material-ui-pickers/TimePicker'
import DatePicker from 'material-ui-pickers/DatePicker'
import DateTimePicker from 'material-ui-pickers/DateTimePicker'
import moment from 'moment'
import MomentUtils from 'material-ui-pickers/utils/moment-utils'
moment.suppressDeprecationWarnings = true;

const EnableDisableSwitch = withRole((props) => {
  return (<Switch disabled {...props} />)
}, [...ROLES_IDEAL_ADMIN, ...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER], (props) => {
  return (<Switch disabled {...props} />)
})

class UsersList extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedDateTime: null
    }
  }

  componentWillMount() {

    const { users, translate, defaultColumns, filterable, classes } = this.props

    let columns = []
    // if(users && users.data){

    // }
    users.columns.forEach((column, index) => {
      columns.push({
        id: column.field,
        Header: translate(column.field),
        accessor: d => d[column.field],
        show: defaultColumns.includes(column.field),
        display: column.display,
        filterable: column.cansearch && filterable,
        cansearch: column.cansearch,
        sortable: column.cansort
      })
    })

    columns.push({
      id: 'detail',
      Header: translate("action"),
      accessor: d => d.UserName,
      show: true,
      Cell: o => (
        <Button raised className={classes.button} onClick={() => this.showConfirmImp(o.row)}>{translate("general_impersonate")}</Button>
      ),
      filterable: false,
      sortable: false
    })

    this.setState({
      columns: columns,
      showConfirmImp: false,
      selectedUser: null
    })
    this.showConfirmImp = this.showConfirmImp.bind(this)
    this.hideConfirmImp = this.hideConfirmImp.bind(this)
    this.impersonate = this.impersonate.bind(this);
  }
  showConfirmImp(row) {
    this.setState({
      showConfirmImp: true,
      selectedUser: { ...row }
    })
  }
  hideConfirmImp() {
    this.setState({
      showConfirmImp: false,
      selectedUser: null
    })
  }
  impersonate() {
    this.hideConfirmImp()
    this.props.impersonationRequest({
      uid: this.state.selectedUser.id,
      CustomerId: this.state.selectedUser.customerid
    })
  }

  render() {

    const {
      users,
      translate,
      pager,
      filterable,
      fetch
    } = this.props

    const {
      columns
    } = this.state

    let confirmImpText = translate('org_user_imp_confirm_text', {
      firstname: (this.state.selectedUser && this.state.selectedUser.firstname) ? this.state.selectedUser.firstname : '',
      lastname: (this.state.selectedUser && this.state.selectedUser.lastname) ? this.state.selectedUser.lastname : '',
      email: (this.state.selectedUser && this.state.selectedUser.email) ? this.state.selectedUser.email : '',
      customer_name: (this.state.selectedUser && this.state.selectedUser.customer_name) ? this.state.selectedUser.customer_name : ''
    })
    if (users) {

      return (
        <React.Fragment>
          <Table
            translate={translate}
            filterable={filterable}
            pages={users.pagecount}
            manual={pager.manual}
            defaultPageSize={pager.pagesize}
            data={users.data}
            columns={columns}
            fetch={fetch}
            style={{
              border: 'none',
            }}
          // onPageChange={this.onPageChange} // Called when the page index is changed by the user
          // onPageSizeChange={this.onPageSizeChange} // Called when the pageSize is changed by the user. The resolve page is also sent to maintain approximate position in the data
          // onSortedChange={this.onSortedChange} // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, `column` will be an array of columns
          // onFilteredChange={this.onFilteredChange} // Called when a user enters a value into a filter input field or the value passed to the onFiltersChange handler by the Filter option.
          />
          <ConfirmDialog
            open={this.state.showConfirmImp}
            title={translate('org_user_imp_confirm_title')}
            contentText={confirmImpText}
            contentSecondaryText={translate('general_confirmation_help_1')}
            okText={translate('general_confirm')}
            cancelText={translate('general_cancel')}
            onOk={this.impersonate}
            onCancel={this.hideConfirmImp}
          />
        </React.Fragment>
      )
    } else {
      return null
    }
    /*return (
      (users) ? (
        <Table
          filterable={true}
          data={users.data}
          columns={columns}
          pages={users.pagecount}
          manual={pager.manual}
          defaultPageSize={pager.pagesize}
      />
      {confirmImp}
      ) : (null)
    )*/
  }
  componentWillReceiveProps(nextProps) {

    const { users, translate, defaultColumns, filterable, classes } = nextProps
    const { selectedDateTime } = this.state
    let columns = []
    users.columns.forEach((column, index) => {
      if (column.field === 'enabled') {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          Cell: o => (
            <EnableDisableSwitch
              checked={o.row.enabled}
              onChange={(e) => this.showConfirmDisableEnable(o.row)}
            />
          ),
          display: column.display,
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort
        })

      }
      else if (column.field === 'modifiedat') {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          Cell: o => {
            return o.row.modifiedat ? dateTimeFormatter(o.row.modifiedat) : ''
          },
          toggle: true,
          display: column.display,
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort,
          width: 220,
          Filter: ({ filter, onChange }) => {
            return (
              <React.Fragment>
                <MuiPickersUtilsProvider
                  utils={MomentUtils}
                  moment={moment}
                >
                  <div className="picker">
                    <DateTimePicker
                      value={selectedDateTime}
                      onChange={event => {
                        this.setState({
                          selectedDateTime: event ? event._d : null
                        }, () => {
                          if (!event) {
                            onChange('')
                            return ''
                          }
                          let date = getISODateTimeString(event._d)
                          onChange(date)
                          return date
                        })
                      }}
                      disableFuture={true}
                      clearable
                      ampm={false}
                      format="DD/MM/YYYY HH:mm"
                    />
                  </div>
                </MuiPickersUtilsProvider>
              </React.Fragment>
            )
          }
        })
      }
      else {
        columns.push({
          id: column.field,
          Header: translate(column.field),
          accessor: d => d[column.field],
          show: defaultColumns.includes(column.field),
          display: column.display,
          filterable: column.cansearch && filterable,
          cansearch: column.cansearch,
          sortable: column.cansort
        })
      }
    })

    columns.push({
      id: 'detail',
      Header: translate("action"),
      accessor: d => d.UserName,
      show: true,
      Cell: o => (
        <Button raised className={classes.button} onClick={() => this.showConfirmImp(o.row)}>{translate("general_impersonate")}</Button>
      ),
      filterable: false,
      sortable: false
    })

    this.setState({
      columns: columns
    })

  }

}

export default withStyles(styles)(UsersList)



// WEBPACK FOOTER //
// ./src/components/organisation/users/index.js